import React from 'react';
import { connect } from 'react-redux';
import { getFieldProps } from '../selectors/hybrid';

const Heading = ({label, name, hide}) => {
  let classes = hide ? 'visuallyhidden' : '';
  
  return (
    <h4 className={classes}>{label}</h4>
  );
};

const mapStateToProps = (state, ownProps) => {
  const configuratorState = state.ConfiguratorStore;
  return getFieldProps(configuratorState, ownProps.field.name);
};

export default connect(mapStateToProps)(Heading);